import styles from './FJHeadline.module.less';
import ArrowSvgIcon from '../../../assets/svg/arrow-back.svg?react';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
const FJHeadline = ({ title, titleClassName, gotoBack, autoTransparent = false, right }) => {
    const headerRef = useRef(null);
    const [isTransparent, setIsTransparent] = useState(autoTransparent);
    useEffect(() => {
        if (headerRef.current && autoTransparent) {
            headerRef.current.parentNode.onscroll = e => {
                const scrollTop = e.target.scrollTop;
                if (scrollTop < 20) {
                    setIsTransparent(true);
                } else if (isTransparent) {
                    setIsTransparent(false);
                }
            };
        }
    }, []);
    return (
        <div className={styles.header} ref={headerRef} style={{ background: isTransparent ? 'transparent' : '#FFF' }}>
            <div className={styles.left} onClick={gotoBack}>
                <ArrowSvgIcon />
            </div>
            <div className={classNames(styles.middle, titleClassName)}>{title}</div>
            <div className={styles.right}>{right}</div>
        </div>
    );
};
export default FJHeadline;
